enum FeatureFlag {
    SETTINGS_DISPLAY_LICENSEMANAGEMENT = "SETTINGS_DISPLAY_LICENSEMANAGEMENT",
    SETTINGS_DISPLAY_SIGNATURE = "SETTINGS_DISPLAY_SIGNATURE",
    SETTINGS_DISPLAY_ADMINDASHBOARD = "SETTINGS_DISPLAY_ADMINDASHBOARD",
    SETTINGS_DISPLAY_MODELMANAGEMENT = "SETTINGS_DISPLAY_MODELMANAGEMENT",
    ONBOARDING_DISPLAY_WELCOMEVIDEO = "ONBOARDING_DISPLAY_WELCOMEVIDEO",
    ONBOARDING_DISPLAY_NEWFEATURE = "ONBOARDING_DISPLAY_NEWFEATURE",
    MAIL_ENABLE_DEEPFOCUS = "MAIL_ENABLE_DEEPFOCUS",
    MAIL_ENABLE_ANALYSIS = "MAIL_ENABLE_ANALYSIS",
    ASSISTANT_ENABLE_VOCAL = "ASSISTANT_ENABLE_VOCAL",
    ASSISTANT_ENABLE_PROMPT = "ASSISTANT_ENABLE_PROMPT",
    AGENDA_ENABLE_ACCESS = "AGENDA_ENABLE_ACCESS",
    DEVICESTORAGE_ENABLE_ACCESS = "DEVICESTORAGE_ENABLE_ACCESS",
    DASHBOARD_DISPLAY_CO2 = "DASHBOARD_DISPLAY_CO2",
    SYSTEM_ENABLE_LOGS = "SYSTEM_ENABLE_LOGS",
    SUPPORT_ENABLE_TICKETCREATION = "SUPPORT_ENABLE_TICKETCREATION",
    CUSTOMVIEW_ENABLE_CREATION = "CUSTOMVIEW_ENABLE_CREATION",
}

export default FeatureFlag;
